import { Action } from '../core/Action';
const REGISTER_BIZ = {
  entity: 'REGISTER_BIZ',
  action: Action.HANDLE
};
const CONFIRM_REGISTER_BIZ = {
  entity: 'CONFIRM_REGISTER_BIZ',
  action: Action.HANDLE
};
export { REGISTER_BIZ, CONFIRM_REGISTER_BIZ };